export default __webpack_public_path__ + "static/media/photo-group.a9219c50.svg";